import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
declare var jQuery: any;

@Component({
  selector: 'i18n-translate',
  templateUrl: './i18n.component.html'
})
export class I18nComponent implements OnInit {
    _lang = 'en';

    get lang() {
        return this._lang;
    }
    set lang(val) {
        if (val !== this._lang) {
            this.addLangClass();
        }
        this._lang = val;
    }

    constructor(
        private router: Router,
        public translate: TranslateService
    ) {
        const langList = ['en', 'ko'];
        if (sessionStorage.getItem('selectedLang')) {
            this.lang = sessionStorage.getItem('selectedLang');
        } else {
            const browserLang = this.translate.getBrowserLang();
            const userLang = langList.find(lang => lang === browserLang);
            if (userLang) {
                this.lang = userLang;
            }
        }
        this.translate.addLangs(langList);
        this.translate.setDefaultLang('en');
        this.translate.use(this.lang);
        this.setLang(this.lang);
    }

    ngOnInit(): void {}

    setLang(lang: string): void {
        sessionStorage.setItem('selectedLang', lang);
    }

    changeLang(langSelect): void {
        this.lang = langSelect.value;
        this.translate.use(langSelect.value);
        this.setLang(langSelect.value);

        // const body = document.querySelector('body');
        // if (body.classList.contains('ko')) {
        //     body.classList.remove('ko');
        // } else {
        //     body.classList.add('ko');
        // }
    }

    addLangClass(): void {
        const body = document.querySelector('body');
        if (body.classList.contains('lang-ko')) {
            body.classList.remove('lang-ko');
        } else {
            body.classList.add('lang-ko');
        }
    }
}
